import React, { FC, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import { ChevronRightIcon } from '@heroicons/react/20/solid';
import AlltaLogo  from '../../assets/logo/allta.png';
import AlltaInfo  from '../../assets/logo/allta_intro.png';
import CompanyMap from '../../assets/map/company_map.png';

export interface ListingExperiencesPageProps {
  className?: string;
}



const Home: FC<ListingExperiencesPageProps> = ({
  className = "",
}) => {
  return (
    <div className="relative isolate overflow-hidden bg-white">

	  <div className="mx-auto max-w-7xl px-6 pb-0 pt-10 sm:pb-32 lg:px-8 lg:py-10">
		<Link to={`/`}>
			<a
				className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
			>
				올타 홈 이동
			</a>
		</Link>
				
		<div className="lg:flex mt-10">
			<div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-xl lg:flex-shrink-0 lg:pt-0">
			<img
				alt="Allta"
				src={AlltaLogo}
				className="h-11"
			/>
			<p className="mt-10 text-3xl font-bold tracking-tight text-gray-900">
				글로벌 모터투어를 위한
			</p>
			<p className="text-4xl font-bold tracking-tight text-gray-900">
				모든 컨텐츠가 한자리에 모이기를 바라는 마음에서 시작!
			</p>
			
				<p className="mt-6 text-lg leading-8 text-gray-600">
					안녕하세요 <b>올타</b>입니다.
				</p>
				<p className="mt-5 text-lg leading-8 text-gray-600">
					전세계 모터투어링을 선도하는 저희 올타를 방문 해주셔서 감사드립니다.
				</p>
				
				<p className="mt-5 text-lg leading-8 text-gray-600">
					<b>“All about ride Travel Agency”</b>  올타는 글로벌 모터투어링을 하기위한 여러분의 꿈을 보다 쉽게 이룰 수 있도록 전세계 다양한 투어 상품들을 저희가 직접 다녀보고, 체험 후 엄선하여, 선별한 투어 컨텐츠를 만들고 있습니다.
				</p>
				
				<p className="mt-6 text-lg leading-8 text-gray-600">
					해외 곳곳의 아름다운 드라이빙 코스와 라이딩 코스들로 구성되어 있으며, 다채로운 국내.외 관련 모터스포츠 이벤트투어를 기획하고 있습니다. 
				</p>
				
				<p className="mt-6 text-lg leading-8 text-gray-600">
					크루즈 선박부터 항공, 스포츠카와 바이크 렌트, 숙박, 미슐랭 레스토랑,  체험 액티비티등, 현지에서 언어소통에 문제없이, 여행하는 동안 처음부터 끝까지 여러분과 올타가 함께 소중한 추억이 되도록 만들어 드릴 것입니다. 
				</p>
				
				<p className="mt-6 text-lg leading-8 text-gray-600">
					올타의 전직원을 대신하여 감사말씀을 드립니다. 
				</p>
			{/* <div className="mt-10 flex items-center gap-x-6">
				<Link to={`/`}>
					<a
						className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
					>
						올타 서비스 이용
					</a>
				</Link>
			</div> */}
			</div>
			<div className="mx-auto mt-6 flex max-w-2xl sm:mt-24 lg:ml-10 lg:mr-0 lg:mt-0 lg:max-w-none lg:flex-none xl:ml-32">
			<div className="max-w-3xl flex sm:max-w-5xl lg:max-w-none items-end">
				<div className="-m-2 rounded-xl bg-gray-900/5 p-2 ring-1 ring-inset ring-gray-900/10 lg:-m-4 lg:rounded-2xl lg:p-4">
				<img
					alt="App screenshot"
					src={AlltaLogo}
					
					className="sm:w-auto lg:w-[300px] xl:w-[500px] rounded-md shadow-2xl ring-1 ring-gray-900/10"
				/>
				</div>
			</div>
			</div>
		</div>

		<div className="mt-[100px]">
			
			<div className="w-full  pl-10 pr-10">
				<div className="flex justify-center">
					<p className="mt-10 text-4xl font-bold tracking-tight text-gray-900">
						지도
					</p>
				</div>
				<div className="">
					<p className="mt-10 text-xl tracking-tight text-gray-900">
					<span className="font-bold">Add.</span> 경기도 화성시 동탄신리천로 270, 4층 402-186호 (오산동)
					</p>
					<div className="sm:flex-none lg:flex xl:flex">
						<p className="sm:mt-10 lg:mt-5 xl:mt-5 text-md tracking-tight text-gray-900 mr-5">
							<span className="font-bold">Tel.</span> 070-8057-6837
						</p>
						<p className="sm:mt-1 lg:mt-5 xl:mt-5 text-md tracking-tight text-gray-900 mr-5">
							<span className="font-bold">E-mail.</span> hello@alltacompany.co.kr
						</p>
						<p className="sm:mt-1 lg:mt-5 xl:mt-5 text-md tracking-tight text-gray-900">
							<span className="font-bold">Opening hour.</span> 09:00 ~ 03:00
						</p>
					</div>
				</div>
				<div className="w-full">
					<div className="mt-10" />
					<img
						alt="Company map"
						src={CompanyMap}
						
						className="w-full rounded-md shadow-2xl ring-1 ring-gray-900/10"
					/>
				</div>
				<div className="">
					<p className="mt-10 text-xl tracking-tight text-gray-900">
						<span className="font-bold">방문객 안내사항 :</span> 프라이빗 투어를 위한 미팅만 진행하고 있으며 방문시간을 사전에 필히 문의해주시기 바랍니다.
					</p>
					
				</div>
				
				
			</div>

		</div>	
	  </div>
	  
    </div>
  );
};

export default Home;
